//API模块统一暴露

import * as chef from './modules/chef';
import * as employee from './modules/employee';
import * as dish from './modules/dish';
import * as category from './modules/category';
import * as table from './modules/table';
import * as newOrder from './modules/newOredr';
import * as order from './modules/order';
import * as stats from './modules/stats';
import * as shopSet from './modules/shopSet';
import * as upload from './modules/upload';
import * as banner from './modules/banner';
import * as tableQrCode from './modules/tableQrCode';



export default {
    chef,
    employee,
    dish,
    category,
    table,
    newOrder,
    order,
    stats,
    shopSet,
    upload,
    banner,
    tableQrCode,
}